// extracted by mini-css-extract-plugin
module.exports = {"orderSummaryTrigger":"OrderSummaryTrigger_orderSummaryTrigger___3OWn","icon":"OrderSummaryTrigger_icon__w8KBi","cofDesignV1":"OrderSummaryTrigger_cofDesignV1__IKydK"};